import { fetchSubdivisions } from '../api';
import { useResource } from './useResource';

// Структура организации: дистанции, участки, бригады. Тоже пока только
// список — к чему приписан работник, видно в разделе персонала, а заведение
// и переименование подразделений идут следующим пунктом этапа.
//
// Отключённые подразделения показываются с пометкой: отключение мягкое, и
// исторические ссылки на них остаются (docs/operations/admin-surface.md).

export function SubdivisionsSection({
  token,
  organizationId,
  onUnauthorized,
}: {
  token: string;
  organizationId: string;
  onUnauthorized: () => void;
}) {
  const units = useResource(
    () => fetchSubdivisions(token, organizationId, true),
    onUnauthorized,
    [token, organizationId],
  );

  if (units.loading) return <p className="section__note">Загружаю структуру…</p>;
  if (units.error) return <p className="ui-error">{units.error}</p>;
  const rows = units.data ?? [];
  if (rows.length === 0) return <p className="section__note">В организации не заведено ни одного подразделения.</p>;

  const name = new Map(rows.map((unit) => [unit.id, unit.name] as const));

  return (
    <table className="table">
      <thead>
        <tr>
          <th>Код</th>
          <th>Название</th>
          <th>Входит в</th>
          <th>Состояние</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((unit) => (
          <tr key={unit.id} className={unit.isActive ? undefined : 'table__row--muted'}>
            <td>{unit.code}</td>
            <td>{unit.name}</td>
            <td>{unit.parentId ? (name.get(unit.parentId) ?? 'название не загрузилось') : '—'}</td>
            <td>{unit.isActive ? 'Действует' : 'Отключено'}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
